import CategoryPieCard from 'components/finance/CategoryPieCard';

export default function ExpensePieCard(props: { [x: string]: any }) {
  return <CategoryPieCard type="expense" title="Your Pie Chart" {...props} />;
}
